import { useEffect, useState } from 'react'

import { serverSide } from '_libs/utils/environment'

// This hook is intended as a workaround. Using it should be considered technical debt
function useClientSideOnly() {
  const [shouldRender, setShouldRender] = useState(false)

  useEffect(() => {
    setShouldRender(!serverSide)
  }, [])

  return shouldRender
}

export default useClientSideOnly
